firebird.controller('reactionsAnimationCtrl', [
    '$window',
    '$scope',
    '$timeout',
    '$interval',
    'logService',
    'meetingService',
    'attendeeListService',
    'helperService',
    'themedFeaturesService',
    'config',

    function (
        $window,
        $scope,
        $timeout,
        $interval,
        logService,
        meetingService,
        attendeeListService,
        helperService,
        themedFeaturesService,
        config
    ) {
        var self = this,
            app,
            canvas,
            context,
            width,
            height,
            reactionImg,
            reactionParticles = [],
            allReactions = ['fine', 'thumbsup', 'thumbsdown', 'love', 'sad', 'laughter', 'wow', 'applause'];

        self.getReactionsList = getReactionsList;

        self.showReactionsAnimation = showReactionsAnimation;
        self.reactionsEnabled = meetingService.getWebinarOptions().showReactionsAnimation;
        self.animationFrameID = null;

        self.startDrawLoop = startDrawLoop;
        self.continueDrawLoop = continueDrawLoop;
        self.stopDrawLoop = stopDrawLoop;

        self.meetingReactionsEnabled = meetingService.isMeeting();

        self.addReactions = addReactions;
        self.useCanvasDrawing = false;
        self.getReactions = getReactions;

        self.inCompactMode = false;

        $scope.$on('attendee-partial-property', onAttendeePartialProperty);
        $scope.$on('webinar-options-updated', onWebinarOptionsUpdated);
        $scope.$on('enable-compact-mode', onCompactModeReceived);

        init();

        ////////////////////////

        function init() {
            logService.log('init reactionsAnimationCtrl', self.meetingReactionsEnabled);
            self.useCanvasDrawing = helperService.getQueryParameter('useCanvasDrawing') == 'true';
            //Watch for changes on window resize
            if (meetingService.isWebinar()) {
                angular.element($window).bind('resize', function () {
                    if (width && canvas) {
                        var newWidth = $window.innerWidth >= 1200 ? $window.innerWidth - 300 : $window.innerWidth;
                        width = canvas.width = newWidth;

                        //Styles don't seem to persist after changing canvas width, so we re-apply them
                        applyContextStyles();
                    }
                });
            }

            $timeout(function () {
                // Get Canvas Block and Context
                app = $window.document.getElementById('reactions-animation');
                canvas = $window.document.getElementById('reactions-canvas');
                context = canvas.getContext('2d');

                // Set width and height
                width = canvas.width = app.offsetWidth;
                canvas.style.height = '100%';
                height = canvas.height = app.offsetHeight;
                // Set Image for Canvas
                reactionImg = new Image();

                if (meetingService.isMeeting()) {
                    reactionImg.src = 'img/redesign/icons/reactions/all_reactions_meeting.png';
                } else {
                    reactionImg.src = 'img/reactions/all_reactions.png';
                }

                // Style for attendee name
                applyContextStyles();

                // Draw Reactions
                if (!meetingService.isMeeting()) {
                    if (self.reactionsEnabled) {
                        self.startDrawLoop();
                    }
                } else {
                    if (self.meetingReactionsEnabled) {
                        self.startDrawLoop();
                    }
                }
            });
        }

        function applyContextStyles() {
            if (context) {
                if (meetingService.isWebinar()) {
                    context.font = '12px';
                } else {
                    context.font = '13px noto-sans';
                }
                context.fillStyle = 'white';
                context.shadowColor = 'rgba(0,0,0,0.7)';
                context.shadowOffsetX = 1;
                context.shadowOffsetY = 1;
                context.shadowBlur = 1;
            }
        }

        function onAttendeePartialProperty(e, data) {
            if (meetingService.isWebinar()) {
                if (!config.webinar.reactionsAnimation || !self.reactionsEnabled) {
                    return;
                }
            } else {
                if (!self.meetingReactionsEnabled) {
                    return;
                }
            }

            if (!helperService.getVDIRef().showReactionButton) {
                return;
            }

            if (data.propName && data.propName === 'currentReaction') {
                var name = data.screenName || '';
                var maxReactions = 50;

                if (reactionParticles.length < maxReactions && meetingService.isMeeting()) {
                    reactionParticles.push(new newReaction(data.propValue, name));
                } else if (data.propValue !== 'fine' && reactionParticles.length < maxReactions) {
                    reactionParticles.push(new newReaction(data.propValue, name));
                }
            }
        }

        function addReactions(name, numbers, delay) {
            if (numbers && numbers > 0) {
                for (var i = 0; i < numbers; i++) {
                    $timeout(function () {
                        /* jshint ignore:start */
                        let reactionsList = self.getReactionsList();
                        var randomReaction = reactionsList[Math.floor(reactionsList.length * Math.random())];
                        reactionParticles.push(new newReaction(randomReaction, name));
                        /* jshint ignore:end */
                    }, delay * i);
                }
            }
        }

        function getReactions() {
            return reactionParticles;
        }

        function randomize(min, max) {
            return Math.random() * (max - min) + min;
        }

        function newReaction(reaction, name) {
            // Randomize start x and y position for New Reaction
            if (meetingService.isWebinar()) {
                this.x = width + Math.round(randomize(20, 60));
                this.y = height - Math.round(randomize(40, 100));
                this.amplitude = randomize(0.2, 0.4);
                // Needed for the animation to slowly fade out-- only used in webinars
                this.opacity = 1;
            } else {
                this.x = Math.round(randomize(-20, -60));
                this.y = height - Math.round(randomize(20, 40));
                this.amplitude = randomize(0.05, 0.1);
            }
            this.counter = 0;

            // Randomize Speed
            var speedMin = (width / 400) * 1.2;
            var speedMax = (width / 400) * 1.8;
            this.speed = randomize(speedMin, speedMax);
            this.exiting = false;

            // Randomize Reaction Radius
            //this used to be to take a random variable, that would make emojis vary in size
            //ANYAM-69246 removed that variation so all emojis remain the same size and are the largest ones
            this.scaleX = 0.8;
            this.scaleY = this.scaleX;

            this.width = 50 * this.scaleX;

            // Set Reaction Image
            this.reactionType = self.getReactionsList().indexOf(reaction);

            this.text = name;
            //this is how the names are seperated into two separate strings to be displayed
            var nameArray = name.split(' ');
            this.firstName = nameArray[0];
            var firstNameLength = this.firstName.length;
            //Add the +1 to deal with the leading space after if it is two names
            this.restOfName = name.slice(firstNameLength + 1);
            this.startingDirectionUp = Math.random() >= 0.5;

            this.waveLength = width / randomize(8, 10);

            if (meetingService.isMeeting() && !self.useCanvasDrawing) {
                var reactionElement = $($('#reaction-template').html());
                if (!self.inCompactMode) {
                    reactionElement.css('transform', 'scale(' + (Math.random() * 0.3 + 1) + ')');
                    reactionElement.css('animation-duration', Math.floor(Math.random() * 3 + 4) + 's');
                }

                reactionElement.find('.first-name').text(this.firstName);
                reactionElement.find('.last-name').text(this.restOfName);
                reactionElement.find('.reaction-emoji').addClass('react-' + reaction);
                reactionElement.on('animationend', function (evt) {
                    if (self.inCompactMode) {
                        if (evt.originalEvent.animationName === 'compact_shiftUp') {
                            $(reactionElement).remove();
                            reactionParticles.splice(0, 1);
                        }
                    } else {
                        $(reactionElement).remove();
                        reactionParticles.splice(0, 1);
                    }
                });
                $timeout(function () {
                    reactionElement.addClass('active');
                }, 100);
                reactionElement.appendTo(app);
            }
        }

        function draw() {
            //meeting should be using new emoji implementation
            if (meetingService.isMeeting() && !self.useCanvasDrawing) {
                return;
            }

            // Clear Context Rectangle
            if (reactionParticles.length > 0) {
                context.clearRect(0, 0, width, height);
            }

            for (var i = 0; i < reactionParticles.length; i++) {
                var p = reactionParticles[i];

                // Last Path Animation
                if (meetingService.isWebinar()) {
                    // Center and show AttendeeName for Reactions
                    var textWidth = context.measureText(p.text).width;
                    var getCenterPosition = (textWidth - p.width) / 2;
                    context.fillStyle = 'rgba(255,255,255,' + p.opacity + ')';
                    context.fillText(p.text, p.x - getCenterPosition, p.y);
                    if (p.x < width / 4) {
                        if (!p.exiting) {
                            p.exiting = true;
                        }

                        var webinarScale = width / 4 / 100;

                        p.scaleX -= 0.01 / webinarScale;
                        p.scaleY -= 0.01 / webinarScale;

                        p.x -= 0.5;
                    }

                    if (p.x < width * 0.66) {
                        p.opacity = p.x / (width * 0.66);

                        if (p.opacity < 0) {
                            p.opacity = 0;
                        }
                    }

                    // ** Wave Path Animation **
                    if (p.startingDirectionUp) {
                        p.y = Math.sin(p.x / p.waveLength) * (height / 2) * p.amplitude + height / 2;
                    } else {
                        p.y = Math.cos(p.x / p.waveLength) * (height / 2) * p.amplitude + height / 2;
                    }

                    // Remove element from Array
                    var xWebinarLimit = -10;
                    if (p.x < xWebinarLimit) {
                        var nextWebinarParticle = reactionParticles[i + 1];

                        if (nextWebinarParticle) {
                            if (nextWebinarParticle.x < xWebinarLimit) {
                                reactionParticles.splice(i, 1);
                            }
                        } else {
                            reactionParticles.splice(i, 1);
                        }
                    }

                    p.x -= p.speed;
                } else {
                    //this is because the p.x value is not precisely on the emoji's starting point
                    var startingOffset = p.x + 3;
                    //Only add the bottom half if the user has more than one name as their meeting name
                    if (p.restOfName) {
                        var restOfNameWidth = context.measureText(p.restOfName).width;
                        var getRestOfNameCenterPosition = (restOfNameWidth - p.width) / 2;
                        context.fillText(p.restOfName, startingOffset - getRestOfNameCenterPosition, p.y - 5);
                    }
                    //This is the meeting UI change where the words are split into first and last/restOf name
                    var firstNameWidth = context.measureText(p.firstName).width;

                    var getFirstNameCenterPosition = (firstNameWidth - p.width) / 2;
                    context.fillStyle = 'rgba(255,255,255)';

                    //Need two separate fillTexts so that both names can be centered on different lines
                    //The other fillText occurs if the user has more than one name
                    context.fillText(p.firstName, startingOffset - getFirstNameCenterPosition, p.y - 20);
                    if (p.x > width - width / 4) {
                        if (!p.exiting) {
                            p.exiting = true;
                        }

                        var meetingScale = width / 4 / 100;

                        p.scaleX -= 0.01 / meetingScale;
                        p.scaleY -= 0.01 / meetingScale;

                        p.x += 0.5;
                    }

                    var offsetHeight = height / 6;
                    // ** Wave Path Animation **
                    if (p.startingDirectionUp) {
                        p.y = Math.sin(p.x / p.waveLength) * (height / 2) * p.amplitude + height / 2 + offsetHeight;
                    } else {
                        p.y = Math.cos(p.x / p.waveLength) * (height / 2) * p.amplitude + height / 2 + offsetHeight;
                    }

                    // Remove element from Array
                    var xMeetingLimit = width + 10;
                    if (p.x > xMeetingLimit) {
                        var nextMeetingParticle = reactionParticles[i + 1];

                        if (nextMeetingParticle) {
                            if (nextMeetingParticle.x > xMeetingLimit) {
                                reactionParticles.splice(i, 1);
                            }
                        } else {
                            reactionParticles.splice(i, 1);
                        }
                    }

                    p.x += p.speed;
                }

                // Drawing state that gets saved
                context.save();

                // Last 100px Path Animation
                context.globalAlpha = p.opacity;

                // Set Image and Size for Reaction
                context.setTransform(p.scaleX, 0, 0, p.scaleY, p.x, p.y);
                context.drawImage(reactionImg, p.reactionType * 50, 0, 40, 40, 0, 0, 50, 50);

                // Restore State to saved
                context.restore();
            }

            self.continueDrawLoop();
        }

        function startDrawLoop() {
            if (!self.animationFrameID) {
                self.animationFrameID = $window.requestAnimationFrame(draw);
            }
        }

        function continueDrawLoop() {
            if (meetingService.isWebinar()) {
                if (self.reactionsEnabled) {
                    self.animationFrameID = $window.requestAnimationFrame(draw);
                }
            } else {
                if (self.meetingReactionsEnabled) {
                    self.animationFrameID = $window.requestAnimationFrame(draw);
                }
            }
        }

        function stopDrawLoop() {
            if (self.animationFrameID) {
                //Draw one more time to remove reactions from screen
                reactionParticles = [];
                self.animationFrameID = $window.requestAnimationFrame(draw);

                $window.cancelAnimationFrame(self.animationFrameID);
                self.animationFrameID = null;
            }
        }

        function showReactionsAnimation() {
            return (
                (meetingService.getIsOnAir() && meetingService.getWebinarOptions().showReactionsAnimation) ||
                (meetingService.isMeeting() && self.meetingReactionsEnabled)
            );
        }

        function onWebinarOptionsUpdated() {
            //Only toggle canvas loop if value of showReactionsAnimation changed
            if (self.reactionsEnabled !== meetingService.getWebinarOptions().showReactionsAnimation) {
                self.reactionsEnabled = meetingService.getWebinarOptions().showReactionsAnimation;

                if (self.reactionsEnabled) {
                    self.startDrawLoop();
                } else {
                    self.stopDrawLoop();
                }

                digest();
            }
        }

        function getReactionsList() {
            if (themedFeaturesService.getThemedFeaturesEnabled()) {
                return themedFeaturesService.getThemedReactions().map(reaction => reaction.name);
            } else {
                return allReactions;
            }
        }

        function onCompactModeReceived(e, data) {
            self.inCompactMode = data;
            if (self.inCompactMode) {
                $('#reactions-animation').addClass('compact-mode');
            } else {
                $('#reactions-animation').removeClass('compact-mode');
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
